module.exports = __webpack_public_path__ + "img/austria-colorectal-cancer-male.6785f78e.png";